var _circle, _g, _rect, _rect2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path0, _path1, _path10, _g4, _path11, _path12, _path13, _path14, _path15, _path16, _rect3, _rect4, _rect5, _rect6, _g5, _path17, _path18, _path19, _path20, _path21, _path22, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEmptyView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.5,
    r: 87.5,
    fill: "#F3F4F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10600_7517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 22,
    width: 65,
    height: 132.281,
    rx: 4.5614,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.0174,
    y: 140.026,
    width: 35.3509,
    height: 10.2632,
    rx: 1.71053,
    fill: "#2563EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0174,
    y: 140.026,
    width: 35.3509,
    height: 10.2632,
    rx: 1.71053,
    stroke: "#2563EB",
    strokeWidth: 1.14035
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10600_7517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0615,
    y: 39.1055,
    width: 53.5965,
    height: 14.8246,
    rx: 2.2807,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 46.6727C64.623 46.4437 64.4374 46.258 64.2084 46.258C63.9794 46.258 63.7937 46.4437 63.7937 46.6727C63.7937 46.9017 63.9794 47.0873 64.2084 47.0873C64.4374 47.0873 64.623 46.9017 64.623 46.6727Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 45.2213C64.623 44.9923 64.4374 44.8066 64.2084 44.8066C63.9794 44.8066 63.7937 44.9923 63.7937 45.2213C63.7937 45.4503 63.9794 45.636 64.2084 45.636C64.4374 45.636 64.623 45.4503 64.623 45.2213Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 48.124C64.623 47.895 64.4374 47.7094 64.2084 47.7094C63.9794 47.7094 63.7937 47.895 63.7937 48.124C63.7937 48.353 63.9794 48.5387 64.2084 48.5387C64.4374 48.5387 64.623 48.353 64.623 48.124Z",
    fill: "#D1D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 46.6727C63.1719 46.4437 62.9862 46.258 62.7572 46.258C62.5282 46.258 62.3425 46.4437 62.3425 46.6727C62.3425 46.9017 62.5282 47.0873 62.7572 47.0873C62.9862 47.0873 63.1719 46.9017 63.1719 46.6727Z",
    fill: "#D1D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 45.2213C63.1719 44.9923 62.9862 44.8066 62.7572 44.8066C62.5282 44.8066 62.3425 44.9923 62.3425 45.2213C62.3425 45.4503 62.5282 45.636 62.7572 45.636C62.9862 45.636 63.1719 45.4503 63.1719 45.2213Z",
    fill: "#D1D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 48.124C63.1719 47.895 62.9862 47.7094 62.7572 47.7094C62.5282 47.7094 62.3425 47.895 62.3425 48.124C62.3425 48.353 62.5282 48.5387 62.7572 48.5387C62.9862 48.5387 63.1719 48.353 63.1719 48.124Z",
    fill: "#D1D5DB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10600_7517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0615,
    y: 56.2109,
    width: 53.5965,
    height: 14.8246,
    rx: 2.2807,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 63.7781C64.623 63.5491 64.4374 63.3635 64.2084 63.3635C63.9794 63.3635 63.7937 63.5491 63.7937 63.7781C63.7937 64.0072 63.9794 64.1928 64.2084 64.1928C64.4374 64.1928 64.623 64.0072 64.623 63.7781Z",
    fill: "#D1D5DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 62.3268C64.623 62.0978 64.4374 61.9121 64.2084 61.9121C63.9794 61.9121 63.7937 62.0978 63.7937 62.3268C63.7937 62.5558 63.9794 62.7415 64.2084 62.7415C64.4374 62.7415 64.623 62.5558 64.623 62.3268Z",
    fill: "#D1D5DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 65.2295C64.623 65.0005 64.4374 64.8148 64.2084 64.8148C63.9794 64.8148 63.7937 65.0005 63.7937 65.2295C63.7937 65.4585 63.9794 65.6442 64.2084 65.6442C64.4374 65.6442 64.623 65.4585 64.623 65.2295Z",
    fill: "#D1D5DB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 63.7781C63.1719 63.5491 62.9862 63.3635 62.7572 63.3635C62.5282 63.3635 62.3425 63.5491 62.3425 63.7781C62.3425 64.0072 62.5282 64.1928 62.7572 64.1928C62.9862 64.1928 63.1719 64.0072 63.1719 63.7781Z",
    fill: "#D1D5DB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 62.3268C63.1719 62.0978 62.9862 61.9121 62.7572 61.9121C62.5282 61.9121 62.3425 62.0978 62.3425 62.3268C62.3425 62.5558 62.5282 62.7415 62.7572 62.7415C62.9862 62.7415 63.1719 62.5558 63.1719 62.3268Z",
    fill: "#D1D5DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 65.2295C63.1719 65.0005 62.9862 64.8148 62.7572 64.8148C62.5282 64.8148 62.3425 65.0005 62.3425 65.2295C62.3425 65.4585 62.5282 65.6442 62.7572 65.6442C62.9862 65.6442 63.1719 65.4585 63.1719 65.2295Z",
    fill: "#D1D5DB"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_10600_7517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0615,
    y: 73.3154,
    width: 53.5965,
    height: 14.8246,
    rx: 2.2807,
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 80.8836C64.623 80.6546 64.4374 80.4689 64.2084 80.4689C63.9794 80.4689 63.7937 80.6546 63.7937 80.8836C63.7937 81.1126 63.9794 81.2983 64.2084 81.2983C64.4374 81.2983 64.623 81.1126 64.623 80.8836Z",
    fill: "#D1D5DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 79.4323C64.623 79.2032 64.4374 79.0176 64.2084 79.0176C63.9794 79.0176 63.7937 79.2032 63.7937 79.4323C63.7937 79.6613 63.9794 79.8469 64.2084 79.8469C64.4374 79.8469 64.623 79.6613 64.623 79.4323Z",
    fill: "#D1D5DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.623 82.335C64.623 82.1059 64.4374 81.9203 64.2084 81.9203C63.9794 81.9203 63.7937 82.1059 63.7937 82.335C63.7937 82.564 63.9794 82.7496 64.2084 82.7496C64.4374 82.7496 64.623 82.564 64.623 82.335Z",
    fill: "#D1D5DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 80.8836C63.1719 80.6546 62.9862 80.4689 62.7572 80.4689C62.5282 80.4689 62.3425 80.6546 62.3425 80.8836C62.3425 81.1126 62.5282 81.2983 62.7572 81.2983C62.9862 81.2983 63.1719 81.1126 63.1719 80.8836Z",
    fill: "#D1D5DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 79.4323C63.1719 79.2032 62.9862 79.0176 62.7572 79.0176C62.5282 79.0176 62.3425 79.2032 62.3425 79.4323C62.3425 79.6613 62.5282 79.8469 62.7572 79.8469C62.9862 79.8469 63.1719 79.6613 63.1719 79.4323Z",
    fill: "#D1D5DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1719 82.335C63.1719 82.1059 62.9862 81.9203 62.7572 81.9203C62.5282 81.9203 62.3425 82.1059 62.3425 82.335C62.3425 82.564 62.5282 82.7496 62.7572 82.7496C62.9862 82.7496 63.1719 82.564 63.1719 82.335Z",
    fill: "#D1D5DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0615,
    y: 29.9824,
    width: 46.7544,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1846,
    y: 44.8066,
    width: 21.6667,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1846,
    y: 61.9121,
    width: 30.7895,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1846,
    y: 79.0176,
    width: 36.4912,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_10600_7517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 82,
    width: 53.5965,
    height: 14.8246,
    rx: 2.2807,
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0615 89.5682C77.0615 89.3392 76.8759 89.1535 76.6469 89.1535C76.4178 89.1535 76.2322 89.3392 76.2322 89.5682C76.2322 89.7972 76.4178 89.9829 76.6469 89.9829C76.8759 89.9829 77.0615 89.7972 77.0615 89.5682Z",
    fill: "#D1D5DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0615 88.1168C77.0615 87.8878 76.8759 87.7021 76.6469 87.7021C76.4178 87.7021 76.2322 87.8878 76.2322 88.1168C76.2322 88.3458 76.4178 88.5315 76.6469 88.5315C76.8759 88.5315 77.0615 88.3458 77.0615 88.1168Z",
    fill: "#D1D5DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0615 91.0195C77.0615 90.7905 76.8759 90.6049 76.6469 90.6049C76.4178 90.6049 76.2322 90.7905 76.2322 91.0195C76.2322 91.2486 76.4178 91.4342 76.6469 91.4342C76.8759 91.4342 77.0615 91.2486 77.0615 91.0195Z",
    fill: "#D1D5DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6104 89.5682C75.6104 89.3392 75.4247 89.1535 75.1957 89.1535C74.9667 89.1535 74.781 89.3392 74.781 89.5682C74.781 89.7972 74.9667 89.9829 75.1957 89.9829C75.4247 89.9829 75.6104 89.7972 75.6104 89.5682Z",
    fill: "#D1D5DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6104 88.1168C75.6104 87.8878 75.4247 87.7021 75.1957 87.7021C74.9667 87.7021 74.781 87.8878 74.781 88.1168C74.781 88.3458 74.9667 88.5315 75.1957 88.5315C75.4247 88.5315 75.6104 88.3458 75.6104 88.1168Z",
    fill: "#D1D5DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6104 91.0195C75.6104 90.7905 75.4247 90.6049 75.1957 90.6049C74.9667 90.6049 74.781 90.7905 74.781 91.0195C74.781 91.2486 74.9667 91.4342 75.1957 91.4342C75.4247 91.4342 75.6104 91.2486 75.6104 91.0195Z",
    fill: "#D1D5DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.623,
    y: 87.7021,
    width: 12.5439,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3066,
    y: 87.7021,
    width: 27.3684,
    height: 3.42105,
    rx: 1.71053,
    fill: "#D1D5DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10600_7517",
    x: 48.6579,
    y: 17.4386,
    width: 78.6842,
    height: 145.964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2807
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10600_7517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10600_7517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10600_7517",
    x: 53.2194,
    y: 34.5441,
    width: 67.2809,
    height: 28.5084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2807
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10600_7517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10600_7517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10600_7517",
    x: 53.2194,
    y: 51.6495,
    width: 67.2809,
    height: 28.5084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2807
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10600_7517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10600_7517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_10600_7517",
    x: 53.2194,
    y: 68.754,
    width: 67.2809,
    height: 28.5084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2807
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10600_7517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10600_7517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_10600_7517",
    x: 65.6579,
    y: 77.4386,
    width: 67.2809,
    height: 28.5084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2807
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10600_7517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10600_7517",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyView);
export default __webpack_public_path__ + "static/media/new-empty-view.88dcff5a05a0288b05843941114bf992.svg";
export { ForwardRef as ReactComponent };